import React from 'react';
import { Award, CheckCircle2, ArrowUpRight, Mail } from 'lucide-react';

interface DashboardTierBenefitsProps {
  tier: string;
  tierDisplayName: string;
  commissionRatePercent: number;
}

export const DashboardTierBenefits: React.FC<DashboardTierBenefitsProps> = ({
  tier,
  tierDisplayName,
  commissionRatePercent,
}) => {
  const isGrowth = tier === 'growth';

  return (
    <div className="bg-[#0E1015] border border-zinc-800/80 rounded-2xl p-6 flex flex-col justify-between">
      <div>
        <div className="flex items-center justify-between pb-3 border-b border-zinc-800">
          <span className="text-xs font-semibold uppercase text-zinc-400 tracking-wider">
            Your Program Tier
          </span>
          <span className="text-xs font-bold text-indigo-400 uppercase px-2 py-0.5 bg-indigo-500/10 rounded-md border border-indigo-500/30">
            {tierDisplayName}
          </span>
        </div>

        <div className="mt-4 p-3.5 bg-indigo-950/20 border border-indigo-500/20 rounded-xl">
          <p className="text-sm font-semibold text-white flex items-center gap-1.5">
            <Award className="w-4 h-4 text-indigo-400" />
            <span>{commissionRatePercent}% Commission Rate</span>
          </p>
          <p className="text-xs text-zinc-300 mt-1 leading-relaxed">
            {isGrowth
              ? 'Lifetime recurring revenue share on all referred client subscriptions.'
              : 'Earn 20% on every payment made by your referred customers for their first 6 months.'}
          </p>
        </div>

        <div className="mt-4 space-y-2 text-xs text-zinc-400">
          <p className="text-[11px] font-semibold text-zinc-300 uppercase tracking-wider mb-2">
            Included Partner Benefits
          </p>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 shrink-0" />
            <span>Automated monthly payouts via bKash, Nagad, or Bank</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 shrink-0" />
            <span>60-day attribution cookie on shared referral links</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 shrink-0" />
            <span>Dedicated marketing banners and agency onboarding guides</span>
          </div>
        </div>
      </div>

      <div className="pt-6 border-t border-zinc-800 mt-6">
        <a
          href="mailto:partners@conversora.io?subject=Partner%20Tier%20Upgrade%20Inquiry"
          className="w-full flex items-center justify-center gap-2 py-2.5 px-3 bg-zinc-900 hover:bg-zinc-800 text-zinc-200 text-xs font-medium rounded-xl border border-zinc-700/60 transition"
        >
          <Mail className="w-3.5 h-3.5 text-indigo-400" />
          <span>Contact Partner Team</span>
          <ArrowUpRight className="w-3.5 h-3.5" />
        </a>
      </div>
    </div>
  );
};
